import type { Challenge } from '@/types/Types'
import { getDb } from './offlineDb'

const STORE_NAME = 'challenges'

export async function saveChallenge(challenge: Challenge) {
  const db = await getDb()
  await db.put(STORE_NAME, challenge)
}

export async function loadChallenge(challengeId: string): Promise<Challenge> {
  const db = await getDb()
  return db.get(STORE_NAME, challengeId)
}

export async function clearChallenge(challengeId: string) {
  const db = await getDb()
  await db.delete(STORE_NAME, challengeId)
}
